<main
  class="relative flex min-h-screen items-center justify-center overflow-hidden bg-hero-gradient px-4 py-20 sm:px-6 [@media(max-height:820px)]:py-12"
>
  <div aria-hidden="true" class="private-browsing-grid pointer-events-none absolute inset-0"></div>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-[#6E72F0]/40 blur-3xl"
  ></div>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute -bottom-40 -right-24 h-[28rem] w-[28rem] rounded-full bg-[#14163F]/60 blur-3xl"
  ></div>

  <img
    [src]="imageEnum.COMPANY_ICON"
    alt="Charaka"
    class="absolute left-5 top-5 h-10 w-10 sm:left-10 sm:top-8 sm:h-12 sm:w-12"
  />

  <section
    aria-labelledby="private-browsing-title"
    class="private-browsing-card relative w-full max-w-xl rounded-[28px] bg-white px-6 pb-8 pt-10 text-center shadow-[0_30px_80px_-20px_rgba(15,17,60,0.6)] sm:px-10 sm:pb-10 sm:pt-12"
  >
    <div class="relative mx-auto flex h-24 w-24 items-center justify-center">
      <span
        aria-hidden="true"
        class="private-browsing-halo absolute inset-0 rounded-full bg-mock-indigo-100"
      ></span>
      <span
        class="relative flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-brand-primary to-brand-secondary shadow-lg shadow-brand-primary/30"
      >
        <!-- Incognito: hat and glasses -->
        <svg viewBox="0 0 24 24" class="h-11 w-11 text-white" aria-hidden="true">
          <path
            fill="currentColor"
            d="M5.6 10.4 7.1 5.3a1.5 1.5 0 0 1 1.95-.97L12 5.4l2.95-1.07a1.5 1.5 0 0 1 1.95.97l1.5 5.1Z"
          />
          <rect x="2.5" y="10.2" width="19" height="1.9" rx=".95" fill="currentColor" />
          <g fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">
            <circle cx="7.6" cy="16.6" r="2.9" />
            <circle cx="16.4" cy="16.6" r="2.9" />
            <path d="M10.5 16.3c1-.6 2-.6 3 0" />
          </g>
        </svg>
      </span>
      <span
        class="absolute bottom-1 right-1 flex h-8 w-8 items-center justify-center rounded-full bg-red-500 ring-4 ring-white"
      >
        <svg viewBox="0 0 20 20" class="h-3.5 w-3.5 text-white" aria-hidden="true">
          <path
            d="M5 5l10 10M15 5 5 15"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </span>
    </div>

    <p
      class="mt-6 inline-flex items-center gap-2 rounded-full bg-mock-ember-50 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-mock-ember-700"
    >
      <span aria-hidden="true" class="h-1.5 w-1.5 rounded-full bg-mock-ember-500"></span>
      Private window detected
    </p>

    <h1
      id="private-browsing-title"
      class="mt-4 text-2xl font-semibold leading-tight text-text-primary sm:text-[28px]"
    >
      This test can't be opened in an incognito window
    </h1>
    <p class="mx-auto mt-3 max-w-md text-[15px] leading-relaxed text-text-secondary">
      To keep your test secure and fair, Charaka Mock Test only runs in a regular browser window.
      Please use a secure browser such as Google Chrome or Mozilla Firefox.
    </p>

    <div class="mt-8 grid grid-cols-1 gap-3 xsm:grid-cols-2 sm:gap-4">
      <div
        class="flex items-center gap-3 rounded-2xl border border-mock-gray-200 bg-mock-gray-50 px-4 py-3 text-left"
      >
        <svg viewBox="0 0 48 48" class="h-10 w-10 shrink-0" aria-hidden="true">
          <path fill="#EA4335" d="M43.6 14A22 22 0 0 0 5.54 12.03L15.34 29A10 10 0 0 1 24 14Z" />
          <path
            fill="#34A853"
            d="M5.54 12.03A22 22 0 0 0 22.86 45.97L32.66 29A10 10 0 0 1 15.34 29Z"
          />
          <path fill="#FBBC04" d="M22.86 45.97A22 22 0 0 0 43.6 14H24A10 10 0 0 1 32.66 29Z" />
          <circle cx="24" cy="24" r="10" fill="#fff" />
          <circle cx="24" cy="24" r="8" fill="#4285F4" />
        </svg>
        <div class="min-w-0">
          <p class="text-sm font-semibold text-text-primary">Google Chrome</p>
          <p class="mt-0.5 text-xs text-text-secondary">Normal window</p>
        </div>
      </div>

      <div
        class="flex items-center gap-3 rounded-2xl border border-mock-gray-200 bg-mock-gray-50 px-4 py-3 text-left"
      >
        <svg viewBox="0 0 48 48" class="h-10 w-10 shrink-0" aria-hidden="true">
          <defs>
            <linearGradient
              id="pb-firefox-flame"
              x1="40"
              y1="6"
              x2="8"
              y2="44"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stop-color="#FFE226" />
              <stop offset=".45" stop-color="#FF7139" />
              <stop offset="1" stop-color="#E31587" />
            </linearGradient>
            <linearGradient
              id="pb-firefox-globe"
              x1="32"
              y1="8"
              x2="12"
              y2="36"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stop-color="#9059FF" />
              <stop offset="1" stop-color="#0250BB" />
            </linearGradient>
          </defs>
          <circle cx="25" cy="25" r="21" fill="url(#pb-firefox-flame)" />
          <circle cx="20.5" cy="20.5" r="15.5" fill="url(#pb-firefox-globe)" />
        </svg>
        <div class="min-w-0">
          <p class="text-sm font-semibold text-text-primary">Mozilla Firefox</p>
          <p class="mt-0.5 text-xs text-text-secondary">Normal window</p>
        </div>
      </div>
    </div>

    <div class="mt-6 rounded-2xl bg-mock-indigo-50 p-5 text-left">
      <p class="text-xs font-semibold uppercase tracking-wider text-brand-primary">
        How to continue
      </p>
      <ol class="mt-3 space-y-3">
        <li class="flex items-start gap-3">
          <span
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-primary text-xs font-semibold text-white"
            >1</span
          >
          <p class="text-sm leading-6 text-mock-gray-900">
            Copy your test link below and close this private window.
          </p>
        </li>
        <li class="flex items-start gap-3">
          <span
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-primary text-xs font-semibold text-white"
            >2</span
          >
          <p class="text-sm leading-6 text-mock-gray-900">
            Open Chrome or Firefox in a normal (non-incognito) window.
          </p>
        </li>
        <li class="flex items-start gap-3">
          <span
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-primary text-xs font-semibold text-white"
            >3</span
          >
          <p class="text-sm leading-6 text-mock-gray-900">
            Paste the link in the address bar and sign in to continue.
          </p>
        </li>
      </ol>
    </div>

    <div
      class="mt-5 flex items-center gap-2 rounded-xl border border-mock-gray-200 bg-white p-1.5 pl-4"
    >
      <svg
        viewBox="0 0 24 24"
        class="h-4 w-4 shrink-0 text-text-secondary"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
        <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
      </svg>
      <span class="min-w-0 flex-1 select-all truncate text-left text-sm text-mock-gray-800">
        {{ testLink }}
      </span>
      <button
        type="button"
        class="inline-flex shrink-0 items-center gap-1.5 rounded-lg px-4 py-2 text-sm font-semibold text-white transition"
        [class]="
          linkCopied()
            ? 'bg-mock-green-500'
            : 'bg-gradient-to-l from-brand-secondary to-brand-primary hover:shadow-md hover:shadow-brand-primary/30'
        "
        (click)="copyTestLink()"
      >
        @if (linkCopied()) {
          <svg
            viewBox="0 0 24 24"
            class="h-4 w-4"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
          Copied
        } @else {
          Copy link
        }
      </button>
    </div>
    <span class="sr-only" aria-live="polite">{{ linkCopied() ? 'Test link copied' : '' }}</span>

    <p class="mt-6 flex items-center justify-center gap-1.5 text-xs text-text-secondary">
      <svg
        viewBox="0 0 24 24"
        class="h-3.5 w-3.5 shrink-0"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <rect x="4.5" y="10.5" width="15" height="10" rx="2" />
        <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
      </svg>
      Private windows bypass the safeguards that keep your test session secure.
    </p>
  </section>
</main>
